module.exports = __webpack_public_path__ + "static/img/examshare_lbt_pic3.6b42be9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examshare_lbt_pic3.png
// module id = kqFP
// module chunks = 0